module.exports = __webpack_public_path__ + "img/1.6231a4d4.jpg";